const GallerySlider = {

    init() {
        this.el = $('[component="gallery"] .slider');
        this.tabs = $('[component="gallery"] .category .tab');
        if (!this.el.length) return;
        this.bind();
    },

    bind() {
        $('[url="galeria"] [block="menu"] h1').hide();

        this.el.addClass('owl-carousel');
        let carousel = this.initCarousel();

        this.tabs.on('click', (event) => {
            carousel.trigger('destroy.owl.carousel');

            const tab = $(event.currentTarget);
            const url = tab.attr('url');
            tab.parent().find('.active').removeClass('active');
            tab.addClass('active');

            const images = galeryImages.filter((image) => {
                return image['url'] === url;
            });

            this.el.empty();

            images[0].image.forEach((image, index) => {
                const slideHTML = `
                    <div class="slide image" data-aos="zoom-out" data-aos-delay="0" order="${index + 1}">
                        <img src="/brands/primlynoch/${image}?w=616&h=462" alt="" />
                    </div>
                `;
                this.el.append(slideHTML);
            });

            carousel = this.initCarousel();
        });
    },

    initCarousel() {
        const carousel = this.el.owlCarousel({
            "loop": false,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "margin": 32,
            "stagePadding": 0,
            "items": 2,
            navText: [
                '<span aria-label="' + 'Previous' + '" icon="arrow_forward"></span>',
                '<span aria-label="' + 'Next' + '" icon="arrow_forward"></span>'
            ],
            responsive : {
                0 : {
                    items : 1,
                },
                768 : {
                    items : 2,
                }
            }
        });

        $(".owl-carousel").each(function (index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls' data-aos='fade-up' data-aos-delay='800'></div>");
        });

        return carousel;
    }
}

export default GallerySlider;